import { prefetchPage as prefetchLegacyPage } from 'pricing-pages-ui/routes/loadablePages';
import { PublicCommerceHubPage, PublicContentHubPage, PublicDataHubPage, PublicFreeToolsPage, PublicMarketingHubPage, PublicMarketingPlusPage, PublicSalesHubPage, PublicServiceHubPage, PublicSmartCrmPage, PublicPlatformPage } from '../pages/loadablePages';
import { getProductGroupBySlug } from '../utils/getProductGroupBySlug';
const STANDALONE_LOADABLES = {
  suite: PublicPlatformPage,
  marketing: PublicMarketingHubPage,
  'marketing-plus': PublicMarketingPlusPage,
  sales: PublicSalesHubPage,
  service: PublicServiceHubPage,
  content: PublicContentHubPage,
  data: PublicDataHubPage,
  commerce: PublicCommerceHubPage,
  crm: PublicFreeToolsPage,
  'smart-crm': PublicSmartCrmPage
};
export function prefetchPublicPage(navItem) {
  if (getProductGroupBySlug(navItem)) {
    const loadable = STANDALONE_LOADABLES[navItem];
    if (loadable) {
      void loadable.preload();
    }
    return;
  }
  prefetchLegacyPage(navItem);
}